import { Box, Divider, alpha } from '@mui/material';

import { HorizontalCarousel, SizingMultiplier } from '@ocx/ui';

import { CategoryPill } from '../category-pill/category-pill.component';
import { LocationSelectorController } from '../location-selector/location-selector.controller';
import { LocationAndCategorySelectorProps } from './location-and-category-selector.types';
import { DIVIDER_HEIGHT, SPACING_BETWEEN_CATEGORIES } from './location-and-category-selector.constants';

export const LocationAndCategorySelector = ({
  onCategoryChange,
  categories,
  selectedCategory,
  onLocationClick,
  isSticky = false,
}: LocationAndCategorySelectorProps) => {
  return (
    <Box
      sx={{
        background: (theme) =>
          `linear-gradient(0deg, ${alpha(theme.palette.background.default, 0)} 0%, ${alpha(
            theme.palette.background.default,
            0.96,
          )} 37%)`,
        ...(isSticky && {
          position: 'sticky',
          top: 0,
          zIndex: 1,
        }),
      }}
      py={SizingMultiplier.sm}>
      <HorizontalCarousel spacing={SPACING_BETWEEN_CATEGORIES}>
        <LocationSelectorController onLocationClick={onLocationClick} />

        <Divider orientation="vertical" sx={{ height: DIVIDER_HEIGHT }} />

        {categories.map(({ id, title }) => {
          const isSelected = selectedCategory ? selectedCategory.id === id : false;
          return (
            <CategoryPill key={id} isSelected={isSelected} onClick={() => onCategoryChange(id)}>
              {title}
            </CategoryPill>
          );
        })}
      </HorizontalCarousel>
    </Box>
  );
};
